import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { ACTION_TRIGGER, RaisedHandIcon } from '../../../../participants-pane/constants.web';
import participantsPaneTheme from '../../../components/themes/participantsPaneTheme.json';
import { isMobileBrowser } from '../../../environment/utils';
import { withPixelLineHeight } from '../../../styles/functions.web';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            alignItems: 'center',
            color: theme.palette.default00,
            display: 'flex',
            ...withPixelLineHeight(theme.typography.bodyShortBold),
            padding: `${theme.spacing(1)} 8px ${theme.spacing(1)} 0`,
            position: 'relative',
            boxShadow: 'inset 0px -1px 0px rgba(255, 255, 255, 0.15)',
            minHeight: '40px',
            transitionDuration: '0.2s',
            '& .actions': {
                display: 'flex',
                position: 'relative',
                top: 'auto',
                // boxShadow: `-15px 0px 10px -5px ${theme.palette.ui02}`,
                // backgroundColor: theme.palette.ui02
            },
            '&:hover': {
                backgroundColor: theme.palette.bgParticipantHover,
                borderRadius: '6px',
                '& .indicators': {
                // display: 'none'
                },
                // '& .actions': {
                //     display: 'flex',
                //     position: 'relative',
                //     top: 'auto',
                //     boxShadow: `-15px 0px 10px -5px ${theme.palette.ui02}`,
                //     backgroundColor: theme.palette.ui02
                // }
            },
            [`@media(max-width: ${participantsPaneTheme.MD_BREAKPOINT})`]: {
                ...withPixelLineHeight(theme.typography.bodyShortBoldLarge),
                padding: `${theme.spacing(3)} ${participantsPaneTheme.panePadding}px`
            }
        },
        highlighted: {
            // backgroundColor: theme.palette.ui02,
            '& .actions': {
                display: 'flex',
                position: 'relative',
                top: 'auto',
                // boxShadow: `-15px 0px 10px -5px ${theme.palette.ui02}`,
                // backgroundColor: theme.palette.ui02
            }
        },
        detailsContainer: {
            display: 'flex',
            alignItems: 'center',
            flex: 1,
            height: '100%',
            overflow: 'hidden',
            position: 'relative'
        },
        name: {
            display: 'flex',
            flex: 1,
            // marginRight: theme.spacing(2),
            overflow: 'hidden',
            flexDirection: 'column',
            justifyContent: 'flex-start'
        },
        indicators: {
            display: 'flex',
            justifyContent: 'flex-end',
            '& .jitsi-icon-default svg': {
                fill: theme.palette.grey01
            },
            '& > *': {
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center'
            },
            '& > *:not(:last-child)': {
                marginRight: theme.spacing(2)
            },
            '& .jitsi-icon': {
                padding: '3px',
                '& svg': {
                    fill: theme.palette.iconDark,
                    '& path': {
                        fill: theme.palette.iconDark,
                    },
                    '& g': {
                        fill: theme.palette.iconDark,
                    }
                },
                '&.jitsi-icon-pink': {
                    '& svg': {
                    // fill: theme.palette.iconPink,
                    // '& path': {
                    //     fill: theme.palette.iconPink,
                    // },
                    // '& g': {
                    //     fill: theme.palette.iconPink,
                    // },
                    }
                }
            }
        },
        indicatorsHidden: {
        // display: 'none'
        },
        indicatorsLocal: {
            marginRight: '30px',
            display: 'flex',
            justifyContent: 'flex-end',
            '& .jitsi-icon-default svg': {
                fill: theme.palette.grey01
            },
            '& > *': {
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center'
            },
            '& > *:not(:last-child)': {
                marginRight: theme.spacing(2)
            },
            '& .jitsi-icon': {
                padding: '3px',
                '& svg': {
                    fill: theme.palette.iconDark,
                    '& path': {
                        fill: theme.palette.iconDark,
                    },
                    '& g': {
                        fill: theme.palette.iconDark,
                    }
                },
                '&.jitsi-icon-pink': {
                    '& svg': {
                    // fill: theme.palette.iconPink,
                    // '& path': {
                    //     fill: theme.palette.iconPink,
                    // },
                    // '& g': {
                    //     fill: theme.palette.iconPink,
                    // },
                    }
                }
            }
        },
        actionsContainer: {
            position: 'absolute',
            top: '-1000px',
            // boxShadow: `-15px 0px 10px -5px ${theme.palette.ui02}`,
            // backgroundColor: theme.palette.ui02
            '& .iconButton': {
                backgroundColor: theme.palette.white,
                width: '22px',
                height: '22px',
                marginLeft: '8px',
                borderRadius: '3px',
            },
        },
        actionsPermanent: {
            display: 'flex',
            // boxShadow: `-15px 0px 10px -5px ${theme.palette.ui01}`,
            // backgroundColor: theme.palette.ui01
        },
        actionsVisible: {
            display: 'flex',
            // boxShadow: `-15px 0px 10px -5px ${theme.palette.ui02}`,
            // backgroundColor: theme.palette.ui02
        }
    };
});
const ListItem = ({ actions, className, defaultName, icon, id, hideActions = false, indicators, isHighlighted, onClick, onLongPress, onMouseLeave, testId, textChildren, trigger, local, isModerator, isRaisedHand, participantID }) => {
    const { classes, cx } = useStyles();
    const isMobile = isMobileBrowser();
    // const [ , , toggleMenu ] = useContextMenu<string>();
    let timeoutHandler;
    const { raisedHandsQueue } = useSelector((state) => state['features/base/participants']);
    const [timeCount, setTimeCount] = useState(() => {
        return getTimeStampRaisedHandFromParticipantID(participantID);
    });
    const refCountTime = useRef(null);
    /**
     * Set calling long press handler after x milliseconds.
     *
     * @param {TouchEvent} e - Touch start event.
     * @returns {void}
     */
    function _onTouchStart(e) {
        const target = e.touches[0].target;
        timeoutHandler = window.setTimeout(() => onLongPress?.(target), 600);
    }
    /**
     * Cancel calling on long press after x milliseconds if the number of milliseconds is not reached
     * before a touch move(drag), or just clears the timeout.
     *
     * @returns {void}
     */
    function _onTouchMove() {
        clearTimeout(timeoutHandler);
    }
    /**
     * Cancel calling on long press after x milliseconds if the number of milliseconds is not reached yet,
     * or just clears the timeout.
     *
     * @returns {void}
     */
    function _onTouchEnd() {
        clearTimeout(timeoutHandler);
    }
    function formatTimestamp(timestamp, isMillis = true) {
        // Convert timestamp to seconds if it's in milliseconds
        const totalSeconds = isMillis ? Math.floor(timestamp / 1000) : timestamp;
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        if (hours > 0) {
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        }
        else {
            return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        }
    }
    function getTimeStampRaisedHandFromParticipantID(id) {
        let finParticipantById = raisedHandsQueue.find(info => info?.id === id);
        // return moment(finParticipantById?.raisedHandTimestamp).format("HH:mm:ss");
        let value = moment().valueOf() - (finParticipantById?.raisedHandTimestamp ?? 0);
        return value;
    }
    useEffect(() => {
        refCountTime.current = setInterval(() => {
            setTimeCount(prev => {
                return prev + 1000;
            });
        }, 1000);
        return () => {
            if (refCountTime.current !== null) {
                clearInterval(refCountTime.current);
            }
        };
    }, []);
    return (React.createElement("div", { "aria-label": defaultName, className: cx((local && !isModerator) ? "list-item-container-local" : "list-item-container", classes.container, isHighlighted && classes.highlighted, className), "data-testid": testId, id: id, onClick: onClick, role: 'listitem', ...(isMobile
            ? {
                onTouchEnd: _onTouchEnd,
                onTouchMove: _onTouchMove,
                onTouchStart: _onTouchStart
            }
            : {
                onMouseLeave
            }) },
        React.createElement("div", null,
            " ",
            icon,
            " "),
        React.createElement("div", { className: classes.detailsContainer },
            React.createElement("div", { className: classes.name }, textChildren),
            isRaisedHand &&
                React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                    React.createElement("span", { style: { marginRight: '4px' } }, formatTimestamp(timeCount)),
                    " ",
                    RaisedHandIcon),
            indicators && (React.createElement("div", { className: cx('indicators', local ? classes.indicatorsLocal : classes.indicators, (isHighlighted || trigger === ACTION_TRIGGER.PERMANENT) && classes.indicatorsHidden) }, indicators)),
            !hideActions && (React.createElement("div", { className: cx('actions', classes.actionsContainer, trigger === ACTION_TRIGGER.PERMANENT && classes.actionsPermanent, isHighlighted && classes.actionsVisible) }, actions)))));
};
export default ListItem;
